import { Team } from "@velaro/velaro-component-lib";

export interface NewTeam extends Omit<Team, "id"> {}

export const defaultTeamModel: NewTeam = {
  name: "",
  userIds: [],
  routingAction: "AutoRoute",
  unassignAction: "Reroute",
  routingType: "roundRobin",
  isDefault: false,
  inactiveAgentAction: "UnassignAgent",
  unassignWarningTime: 0,
  unassignTime: 0,
  autoResolve: false,
  autoResolveTime: 0,
  //endConversationButtonEnabled: false,
  transferToAgentButtonEnabled: false,
  botAutoReassignmentTime: 0,
  botAutoReassignment: false
};
